import React, { useEffect, useState } from 'react';
import GlobalStyles, { Container } from './styles/GlobalStyles'
import Header from './components/Header'
import Home from './pages/Home';
import Footer from './components/Footer';
import { differenceInHours } from 'date-fns';

function App() {
  const [usuario, setUsuario] = useState('');
  const [logado, setLogado] = useState(false);

  useEffect(() => {
    const decode = localStorage.getItem('Usuario')
    if(decode) {
      const usuario = JSON.parse(atob(decode));
      if(differenceInHours(new Date(usuario.expira), new Date()) !== 0){
        localStorage.removeItem('Usuario')
      }
      else {
        setLogado(true);
        setUsuario(usuario);
      }
    }
  }, [])

  const logout = () => {
    setLogado(false);
    setUsuario('');
    localStorage.removeItem('Usuario')
  }

  const verificaLoginExpirado = () => {
    if(logado) {
      if(differenceInHours(new Date(usuario.expira), new Date()) !== 0){
        logout();
        return true;
      }
    }
    return false;
  }

  return (
    <Container>
      <div>
        <Header logado={logado} usuario={usuario} logout={() => logout()}/>
        <Home logado={logado} usuario={usuario} verificaLoginExpirado={() => verificaLoginExpirado()}/>
      </div>
      <Footer />
      <GlobalStyles />
    </Container>
  );
}

export default App;
